import { QueryClient } from '@tanstack/react-query'

/**
 * Defaults chosen from what the live traffic capture showed
 * (docs/inventory/FINDINGS.md):
 *
 * - The legacy app refetches `api/users/list` and `lc/mgmt/users/filters` on
 *   nearly every route, often twice per load. A shared query key plus a real
 *   staleTime removes most of that without any backend change.
 * - The API is RPC over POST, so nothing is cacheable at the HTTP layer and
 *   every read needs an explicit key. That makes these defaults load-bearing.
 * - Retry is off by default: reads go through POST here, so the usual "GET is
 *   safe to retry" assumption does not hold. Endpoints that are genuinely
 *   idempotent opt in per query.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: false,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: false },
    },
  })
}

/** Reference data that is app-scoped and changes rarely. */
export const REFERENCE_STALE_TIME = 15 * 60_000
